import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Swal from "sweetalert2";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const Profile = () => {
      const navigate = useNavigate();
      const [formdata, setFormData] = useState({
        'nama':''
      }); // State untuk menyimpan daftar kelas
    
 useEffect(() => {
    const fetchMenu = async () => {
      window.initScripts?.();
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.error("Token required");
        return;
      }

      try {
        const decoded = jwtDecode(authToken);
       
        setFormData({...formdata,nama: decoded.nama})
        if (!decoded.akses) {
          navigate('/daftar/identifikasiakses');
        }
      } catch (error) {
        navigate('/login');
        return;
      }
     
    };

    fetchMenu();
  }, [navigate]);

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formdata)

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/gantidata`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
            },
            body: JSON.stringify(formdata),
        });

        if (!response.ok) {
            throw new Error("Gagal menyimpan data");
        }

        const result = await response.json();
        localStorage.setItem('authToken', result.token);
        Swal.fire("Berhasil!", result.message, "success").then(() => {
            $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
        });
    } catch (error) {
         Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
    }
};
    return (
        <>
            <Helmet>
                <title>Profile - Pembelajaran - Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Ubah Biodata dan password</h5>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Nama Pengguna <span className="text-danger">*</span></label>
                                                    <input type="text"   onChange={(e) => setFormData({...formdata,nama:e.target.value})}  value={formdata.nama} className="form-control" placeholder="Ubah Nama Pengguna" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer text-end">
                                        <button className="btn btn-danger" type='Submit'>Ubah Data</button>
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    );

};

export default Profile;